import EdButton, {
  IEdButtonProps,
} from "@/components/generic/edbutton/edButton";
import * as React from "react";
import { Col, Row } from "react-bootstrap";
import { Interface } from "readline";
import CreateNewWatchList from "../CreateWatchList/CreateNewWatchList";

export interface IPopupWatchlist {
  show: boolean;
  setShow: (show: boolean) => void;
  size?: string;
  title?: string | React.ReactNode;
  children?: React.ReactNode;
  icon?: string;
  showFooter: boolean;
  modalTitle: string;
  closeDropdown?: Function;
  closeicon: string;
  showCloseIcon?: boolean;
  btnvalueleft?: IEdButtonProps;
  btnvalueright?: IEdButtonProps;
  footerClassName?: string;
  dontCloseOnOutsideClick?: boolean;
}

const PopupWatchlist: React.FC<IPopupWatchlist> = (props: IPopupWatchlist) => {
  const ref = React.useRef(null);
  React.useEffect(() => {
    const body = document.querySelector("body");
    body.style.overflow = props.show ? "hidden" : "auto";
    return () => {
      body.style.overflow = "auto";
    };
  }, [props.show]);
  React.useEffect(() => {
    function handleClickOutside(event: any) {
      if (
        ref.current &&
        !ref.current.contains(event.target) &&
        event.view.innerWidth - 17 >= event.clientX
      ) {
        props.setShow(false);
      }
    }
    !props?.dontCloseOnOutsideClick &&
      document.addEventListener("mousedown", handleClickOutside);
    return () => {
      !props?.dontCloseOnOutsideClick &&
        document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  return (
    <>
      <div className={`modal-backdrop ${props.show ? "show" : "fade"}`}></div>
      <div
        className={`modal ${props.modalTitle} ${props.show ? "show" : "fade"}`}
      >
        <div className={`modal-dialog ${props.size}`}>
          <div className="modal-content" ref={ref}>
            <div
              className={`modal-header align-items-center justify-content-between`}
            >
              <div className="d-flex justify-conent-between align-items-center">
                {props.icon && <i className={props.icon}></i>}
                {props.title && (
                  <h5 className="modal-title">
                    {props.hasOwnProperty("title") ? props.title : ""}
                  </h5>
                )}
              </div>
              <button
                type="button"
                className={props.showCloseIcon ? props.closeicon : ""}
                onClick={() => {
                  props.setShow(false);
                  setTimeout(() => {
                    props?.closeDropdown && props.closeDropdown(false);
                  }, 0);
                }}
              >
                <i className=""></i>
              </button>
            </div>
            <div className="modal-body">{props.children}</div>
            {props.showFooter && (
              <div className={`modal-footer ${props.footerClassName}`}>
                <Row>
                  <Col lg={12}>
                    <EdButton
                      className="small-edbutton"
                      {...props.btnvalueleft}
                    />
                    <EdButton
                      className="ms-4 small-edbutton"
                      {...props.btnvalueright}
                    />
                  </Col>
                </Row>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default PopupWatchlist;

/******please note pop up designing component (do not delete) */
// create watchlist (screen no 308)
//  <PopupWatchlist
//    size={"modal-md modal-dialog-centered"}
//    icon="edel-icon-download1"
//    modalTitle={"modalwatchlist commonmodal"}
//    title="Name your Watchlist"
//    showFooter={true}
//    show={show}
//    setShow={setShow}
//    showCloseIcon={true}
//    closeicon={"edel-icon-bold-close"}
//  btnvalueleft={{
//                     value: "Cancel",
//                     btnTyp: "midnight-blue-border",
//                   }}
//                   btnvalueright={{
//                     value: "proceed",
//                     btnTyp: "midnight-blue",
//                   }}
//    children={<CreateNewWatchList />}
//  />;

//  <PopupWatchlist 321-screen
//                   size={"modal-md modal-dialog-centered"}
//                   icon="edel-icon-download1"
//                   modalTitle={"modalwatchlist commonmodal"}
//                   title="Warning"
//                   showFooter={true}
//                   show={show}
//                   setShow={setShow}
//                   showCloseIcon={true}
//                   closeicon={"edel-icon-cross"}
//                   btnvalueleft={{
//                     value: "ok",
//                     btnTyp: "midnight-blue",
//                   }}
//
